import React from "react";
import { useTranslation } from "react-i18next";

export default function Destinations() {
  const { t } = useTranslation();

  return (
    <section id="destinations" className="section section-alt">
      <div className="container">
        <header className="section-header">
          <h2>{t("destinations.sectionTitle")}</h2>
          <p>{t("destinations.sectionSubtitle")}</p>
        </header>
        <div className="destinations-grid">
          <article className="destination-card">
            <div className="destination-image dest-1" />
            <div className="destination-body">
              <h3>{t("destinations.item1Title")}</h3>
              <p>{t("destinations.item1Text")}</p>
            </div>
          </article>
          <article className="destination-card">
            <div className="destination-image dest-2" />
            <div className="destination-body">
              <h3>{t("destinations.item2Title")}</h3>
              <p>{t("destinations.item2Text")}</p>
            </div>
          </article>
          <article className="destination-card">
            <div className="destination-image dest-3" />
            <div className="destination-body">
              <h3>{t("destinations.item3Title")}</h3>
              <p>{t("destinations.item3Text")}</p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
